import type { AmazonModuleConfig, GPTModuleConfig, MagniteModuleConfig, } from "@/ts/module";
import type { AdUnits } from "@/ts/prebid/types";
import type { AdSizesConfig, AmazonSlotMapEntry, DisplaySlotConfig, MagniteSize, MagniteSlotMapEntry, } from "@/ts/types";
const REPEAT_SLOT_REGEX = /^div-gpt-ad-mid-article-slot-repeat(-\d+)?$/;
export const isRepeatKey = (key: string) => REPEAT_SLOT_REGEX.test(key);
const getRepeatSlots = (key: string, adUnits: AdUnits) => {
    return {
        ...adUnits["div-gpt-ad-mid-article-slot-repeat"],
        code: key, // update code to match the "repeat-n" pattern
    };
};
export const resolveRepeatSlots = (key: string, adUnits: AdUnits) => {
    return isRepeatKey(key)
        ? getRepeatSlots(key, adUnits) // If the key is a "repeat-n" pattern and "repeat" exists in adUnits, use "repeat"
        : adUnits[key]; // Otherwise, return the key's own configuration
};
export const getRecommenderSlots = (slotId: string, adUnits: AdUnits) => ({
    ...adUnits[slotId],
    code: slotId,
});
export const getSizeForSlot = (slotId: string, config: AmazonModuleConfig["adSizesAmazon"] | MagniteModuleConfig["adSizesMagnite"] | GPTModuleConfig["adSizesGPT"] | undefined) => {
    if (!config) {
        return [];
    }
    if (isRepeatKey(slotId)) {
        return config["div-gpt-ad-mid-article-slot-repeat"];
    }
    return config[slotId];
};
export const filterSlotBySize = (adSizesCfg: AdSizesConfig) => (cmdSlot: DisplaySlotConfig) => {
    return (adSizesCfg &&
        (adSizesCfg[cmdSlot.slotId] ||
            // This handles repeating slots and recommender slots
            Object.keys(adSizesCfg).some((prefix) => cmdSlot.slotId.startsWith(prefix))));
};
const getSlotId = (slotMap: {
    slotID?: string;
    divId?: string;
}) => slotMap.slotID ?? slotMap.divId ?? "";
export const removeUnneededSizes = <T extends AmazonSlotMapEntry | MagniteSlotMapEntry,>(slotMap: T): T => {
    const { sizes } = slotMap;
    const slotId = getSlotId(slotMap);
    const slotElement = document.querySelector<HTMLElement>(`.${slotId}`);
    const slotWidth = slotElement?.offsetWidth || 0;
    const slotHeight = slotElement?.offsetHeight || 0;
    if (!(slotWidth && slotHeight && sizes)) {
        return slotMap;
    }
    const filteredSizes = Array.isArray(sizes[0])
        ? (sizes as [
            number,
            number
        ][]).filter(([w, h]) => w <= slotWidth && h <= slotHeight)
        : (sizes as MagniteSize[]).filter((s) => s.w <= slotWidth && s.h <= slotHeight);
    return {
        ...slotMap,
        sizes: filteredSizes,
    } as T;
};
